{
  "questions": {
    "culture": {
      "detailsPlaceholder": "<p>Fa‘amolemole tusi i le Igilisi. Fa’ata’ita’iga:</p>\n<p>Whānau to be present, need interpreter, specific dietary customs</p>",
      "label": "E iai ni ou manaʻoga fa‘ale-aganu‘u po o le aiga?",
      "nextLabel": "$t(common:next): <b>Isi manaʻoga faʻapitoa poʻo faʻamatalaga</b>",
      "title": "<h3>Manaʻoga faaleaganuʻu po o le aiga</h3>"
    },
    "language": {
      "de": "Deutsch / German",
      "detailsLabel": "O le ā lau gagana e te fiafia e fa’aaogā?",
      "fj": "Vosa Vakaviti / Fijian",
      "fr": "Français / French",
      "ja": "日本語 / Japanese",
      "ko": "한국어 / Korean",
      "label": "E faigatā iā te oe le malamalama i le gagana Peretania?",
      "mi": "Te Reo Māori",
      "ms": "Malay / Malaysian",
      "nextLabel": "$t(common:next): <b>Manaʻoga faalelotu po o faaleagaga</b>",
      "other": "Isi",
      "pt": "Português / Portuguese",
      "sm": "Gagana Samoa / Samoan",
      "ta": "தமிழ் / Tamil",
      "title": "<h3>Malamalama i le gagana Peretania</h3>",
      "tl": "Tagalog / Tagalog",
      "to": "Lea Faka-Tonga / Tongan",
      "zh": "简体中文 / Chinese"
    },
    "mobility": {
      "detailsPlaceholder": "Fa'amolemole fa'atumu i le gagana Peretania. Mo se fa'ata'ita'iga:<br/>Fa'aaoga se au savali po'o se nofoa fa'afoliga; mana'omia se fesoasoani e si'itia i luga o le moega",
      "label": "E iai sau fa’aletonu tumau po’o se mana’oga mo se fesoasoani i le savali?",
      "nextLabel": "$t(common:next): <b>Malamalama i le Igilisi</b>",
      "title": "<h3>Gafatia ona feoa‘i</h3>"
    },
    "other": {
      "detailsPlaceholder": "Fa’asoa na’o mea e te lagona e talafeagai. E fesoasoani lenei mea i le matou lagolagoina atili o oe.",
      "label": "E iai ni isi o ou mana’oga fa’apitoa, pe iai fo’i se isi fa’amatalaga e te mana’o e matou te silafia?",
      "nextLabel": "$t(common:next): <b>Le mauaina o lau sauniuniga o le manava</b>",
      "title": "<h3>Isi manaʻoga faapitoa po o nisi faʻamatalaga</h3>"
    },
    "prep": {
      "label": "Fa’amolemole filifili le auala e te mana’o e maua ai:",
      "nextLabel": "$t(common:next): <b>Fa’amautu le tusi taimi</b>",
      "pick-up-from-hospital": "<label>Piki mai i le {{company}}</label>\n<p>Ao lau pusa sauni i le ofisa i taimi tatala.</p>",
      "pick-up-from-local-pharmacy": "<label>Piki mai i lau faletalavai lata ane</label>\n<p>O le a imeli atu e matou se fomaʻi faʻatonu e te ave i lau faletalavai.</p>",
      "receive-by-mail": "<label>Tali i le meli</label>\n<p>O le a lafo atu e matou le pusa sauni i le tuatusi i le fale na e tuʻuina mai.</p>",
      "text": "Ina ia sauni mo lau taotoga, e tatau ona e inuina se vailaʻau fa’apitoa e faʻamāmā ai lou manava.",
      "title": "<h3>Le tapenaina o lau fualaʻau mo le manava</h3><p>Ina ia sauni mo lau taotoga, e tatau ona e inuina se vailaʻau fa’apitoa e faʻamāmā ai lou manava.</p>"
    },
    "religion": {
      "detailsPlaceholder": "<p>Faʻamolemole ulufale i le gagana Peretania. Fa’ata’ita’iga:<br/>Quiet space for prayer, prefer same-gender staff for personal care</p>",
      "label": "E i ai ni ou manaʻoga faalelotu po’o faaleagaga?",
      "nextLabel": "$t(common:next): <b>Manaʻoga faaleaganuʻu po o aiga</b>",
      "title": "<h3>Manaʻoga faalelotu po o faaleagaga</h3>"
    }
  }
}
